import { Input } from 'design-react-kit/dist/design-react-kit';
import { defineMessages, useIntl } from 'react-intl';
import { useState } from 'react';

const messages = defineMessages({
  emaillabel: {
    id: 'Indirizzo email a cui inviare i dati *',
    defaultMessage: 'Indirizzo email a cui inviare i dati *',
  },
  invalidEmail: {
    id: '* Indirizzo email valido',
    defaulMessage: '* Indirizzo email valido',
  },
  selectOption: {
    id: 'Selezionare una voce',
    defaultMessage: 'Selezionare una voce',
  },
  requiredField: {
    id: '* Campo obbligatorio',
    defaultMessage: '* Campo obbligatorio',
  },
});
const TextField = ({ formData, setFormData, filter, error, setError }) => {
  const intl = useIntl();

  /**
   * Text filter validator
   */
  const textValidator = e => {
    const { value } = e.target;

    setFormData(formData => ({
      ...formData,
      [filter?.propertyField]: value,
    }));

    if (filter?.mandatory && !value) {
      setError(prev => ({
        ...prev,
        [filter?.propertyField]: intl.formatMessage(messages.requiredField),
      }));
    } else {
      setError(prev => ({
        ...prev,
        [filter?.propertyField]: '',
      }));
    }
  };
  return (
    <>
      <Input
        type="text"
        id={filter?.propertyField || filter?.labelField}
        name={filter?.propertyField || filter?.labelField}
        label={
          filter?.mandatory
            ? `${filter?.labelField || filter?.propertyField} * `
            : filter?.labelField || filter?.propertyField
        }
        onChange={textValidator}
        value={formData?.[filter?.propertyField] || ''}
        className="mt-1 mb-0"
        required={filter?.mandatory}
      />
      {error && (
        <label color="danger" htmlFor="startDate-field" className="mt-0 text-danger lh-1 word-wrap">
          <small>{error}</small>
        </label>
      )}
    </>
  );
};

export default TextField;
